/**
 * Community Hub entity constant for query keys
 */
export const ENTITY = 'community-hub';
